import { render, staticRenderFns } from "./ReactivationCourse.vue?vue&type=template&id=ef313494&scoped=true&"
import script from "./ReactivationCourse.vue?vue&type=script&lang=js&"
export * from "./ReactivationCourse.vue?vue&type=script&lang=js&"
import style0 from "./ReactivationCourse.vue?vue&type=style&index=0&id=ef313494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef313494",
  null
  
)

export default component.exports